import React from 'react';

/** 坐标输入组件 - 增强版，支持智能识别 */
export default function CoordinateInput({ label, value, onChange, placeholder, onPaste }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <label style={{ display: 'block', marginBottom: 5, fontWeight: 'bold' }}>{label}</label>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        onPaste={onPaste}
        placeholder={placeholder}
        style={{
          width: '100%',
          padding: '8px 12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          fontSize: '14px'
        }}
      />
    </div>
  );
}
